import APIError from "./APIError";

class UpdateUserReply {
  error?: APIError;
}

export default UpdateUserReply;
